module.exports = __webpack_public_path__ + "media/assets/icons/approveWhite-8ec929f92962dc40b784c8a4e7d08c0c.svg";